import React, { useState, useEffect } from "react";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import {
  InteractionType,
} from "@azure/msal-browser";
import { loginRequest } from "../authConfig.js";

// Sample app imports
import { SalesOrderDetailContent } from "../components/SalesOrder/SalesOrderDetailContent";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";
import { api_path } from "../shared";

export function SalesOrderDetail() {
  const authRequest = {
    ...loginRequest,
  };
  const getUserID = JSON.parse(localStorage.getItem('USER_ID'));
  const getUserRole = JSON.parse(localStorage.getItem('USER_ROLE_ID'));
  const getUserEMail = JSON.parse(localStorage.getItem('USER_EMAIL'));
  const getEmpCode = JSON.parse(localStorage.getItem('USER_EMPCODE'));

  const ShowSaleOrderContent = () => {
    return <SalesOrderDetailContent 
    USER_EMAIL={getUserEMail}
    EMP_CODE={getEmpCode}
    USER_ROLE={getUserRole}
    CRM_ID={getUserID}
    />;
  };
  
  useEffect(() => {
    var data = {
      ROLE_ID: getUserRole,
      USER_EMAIL: getUserEMail,
      MENU_URL:window.location.pathname,
    };
    fetch(api_path + "/GET_AUTHEN_URL.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
          if (result["status"] == "200") {
            if (result["success"] == "0") {
              window.location = "/s-crm/Home?status=denined";
            }
          }
      });
  }, []);
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <ShowSaleOrderContent />
    </MsalAuthenticationTemplate>
  );
}
